import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { PaperPlane } from '../streamlineSolidIcon/PaperPlane';
import { useMobileLayout } from '../utils';
import { StandardButton, type StandardButtonProps } from './StandardButton';

const StyledButton = styled(StandardButton)(({ theme }) => ({
  '&.Mui-disabled': {
    backgroundColor: theme.vars?.palette.primary.main,
    color: theme.vars?.palette.primary.contrastText,
    boxShadow: theme.shadows[2],
    opacity: 0.5,
  },
}));

export const SendButton = ({
  children,
  text = 'Send',
  size,
  ...props
}: StandardButtonProps) => {
  const isMobile = useMobileLayout();
  const icon = <PaperPlane size={size} viewBox="0 0 17 17" />;

  return (
    <Box>
      <StyledButton
        color="primary"
        endIcon={!isMobile && icon}
        variant="contained"
        size={size}
        aria-label={text}
        sx={isMobile ? { minWidth: 'auto', padding: 1.4 } : undefined}
        {...props}
      >
        {isMobile ? (
          icon
        ) : (
          <Typography variant="body1">{children || text}</Typography>
        )}
      </StyledButton>
    </Box>
  );
};
